import React, { useState } from 'react';
import { VendorDashboard } from './VendorDashboard';
import { VendorCatalog } from './VendorCatalog';
import './VendorManagement.css';

interface VendorManagementProps {
  enterpriseId: string;
}

export const VendorManagement: React.FC<VendorManagementProps> = ({ enterpriseId }) => {
  const [activeTab, setActiveTab] = useState<'dashboard' | 'catalog'>('dashboard');

  return (
    <div className="vendor-management">
      <div className="vendor-management-header">
        <h1>Vendor Management</h1>
        <div className="tab-navigation">
          <button
            className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            <span className="tab-icon">[ANALYTICS]</span>
            Dashboard
          </button>
          <button
            className={`tab-button ${activeTab === 'catalog' ? 'active' : ''}`}
            onClick={() => setActiveTab('catalog')}
          >
            <span className="tab-icon">[CATALOG]</span>
            Catalog
          </button>
        </div>
      </div>

      <div className="vendor-management-content">
        {activeTab === 'dashboard' && (
          <VendorDashboard enterpriseId={enterpriseId} />
        )}
        {activeTab === 'catalog' && (
          <VendorCatalog enterpriseId={enterpriseId} />
        )}
      </div>
    </div>
  );
};